import { net_common } from "@/api/http";
export const API_Initialize = (...params) =>
  net_common.post("/api/STDSDC02C01/Initialize", ...params);

export const API_DeleteBopInfo = (...params) =>
  net_common.post("/api/STDSDC02C01/DeleteBopInfo", ...params);
